import React from 'react';
import { Outlet } from 'react-router-dom';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import _ from 'lodash';
import getUserCred from '../../requests/getuserCred';
import NavBar from './NavBar';
import TopBar from './TopBar';

const useStyles = (theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256
    }
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto'
  }
});

class DashboardLayout extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isMobileNavOpen: false
    };
  }

  componentDidMount = async () => {
    const idTokenParsed = _.get(this, ['props', 'keycloak', 'idTokenParsed'], {});
    if (!_.isEmpty(idTokenParsed)) {
      await getUserCred(idTokenParsed.email, idTokenParsed.iss);
    }
  }

  setMobileNavOpen(val) {
    this.setState({ isMobileNavOpen: val });
  }

  render() {
    const { isMobileNavOpen } = this.state;
    const { classes, keycloak } = this.props;

    return (
      <div className={classes.root}>
        <TopBar 
          onMobileNavOpen={() => this.setMobileNavOpen(true)} 
          keycloak={keycloak}
        />
        <NavBar
          onMobileClose={() => this.setMobileNavOpen(false)}
          openMobile={isMobileNavOpen}
          keycloak={keycloak}
        />
        <div className={classes.wrapper}>
          <div className={classes.contentContainer}>
            <div className={classes.content}>
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DashboardLayout.propTypes = {
  classes: PropTypes.any,
  keycloak: PropTypes.any
};

export default withStyles(useStyles)(DashboardLayout);
